interface Mapped<T> {
  name: string;
  value: T;
}

interface PureObj<T> {
  [key: string]: T;
}

/**
 * This method takes an object and maps it to an array of its properties in the as name/value pair.
 * @param object
 */

export default <T>(object: PureObj<T>): Mapped<T>[] => (
  Object.keys(object).map(key => ({
    name: key,
    value: object[key],
  }))
);
